import translation from "./translations";

export const productionConfig = {
  apiUrls: {
    ordersApi: "",
    subscriptionsApi: "",
    invoicesApi: "",
    productsApi: "",
    customerApi: "",
    quotationsApi: "",
    financialsApi: "",
    searchApi: "",
    addressVerificationApi: "",
    salesRepApi: "",
    serviceOrdersApi: "",
    productComparisonApi: "",
    maintenanceBannerApi: "",
    contractsApi: "",
    projectRegistration: "",
    projectRegistrationAddressValidation: "",
    projectRegistrationDistributorData: "",
  },
  contextPath: "",
  navContextPath: "",
  rootUrl: "https://www.boschsecurity.com/en",
  rootLabel: "Bosch Building Technologies | Life Safety Systems",
  pricesConfig: {
    asyncPrices: true,
    timeout: 8000,
    priceApi: "",
    stockApi: "",
  },
  notificationConfig: {
    notificationsApi: "",
    notificationsSettingsApi: "",
    notificationsSettingsSwitchApi: "",
    notificationsSettingsAccountApi: "",
    notificationsFlyoutApi: "",
  },
  adyenPaymentConfig: {
    adyenPaymentDetailsApi: "",
    adyenPaymentJWTApi: "",
    adyenKeyCloakInfoApi: "",
    adyenPaymentResultsApi: "",
    orderPollingApi: "",
  },
  documentsConfig: {
    documentsApi: "",
  },
  consentConfig: {
    consentStatusAPI: "",
    consentAgreeAPI: "",
    consentDisagreeAPI: "",
  },
  wishlistConfig: {
    wishlistsApi: "",
    wishlistsLimit: 8,
  },
  cartConfig: {
    addToCartButtonEnabled: true,
    addToCartButtonQuote2OrderEnabled: true,
    apiKey: "",
    cartPageUrl: "",
    carts: [],
    cartGuid: "0",
    baseSiteId: "shop",
    baseCartApiURL: "/boschfoundationapi",
    maximumCarts: 8,
    multiCartEnabled: true,
    quickAddEnabled: true,
    userId: "gi.sun@bosch.com",
    defaultMaxQuantity: 999999,
    numberOfDigits: 6,
    messageModalLabel: "",
    presentInCartModalLabel: "",
    cancelModalLabel: "",
    increaseQuantityModalLabel: "",
    addNewLineModalLabel: "",
    skipEntryMergeOverlayConfirmation: false,
  },
  inquiryConfig: {
    baseInquiryApiURL: "",
    inquiryCartApiURL: "",
    addToInquiryApiURL: "",
  },
  impersonateConfig: {
    impersonateSearchApi: "",
    impersonateUserSelectApi: "",
    impersonateUserResetApi: "",
  },
  loginUrl: "",
  orderHistoryConfig: {
    cancelEntireOrderVisibility: true,
    cancelOrderItemVisibility: true,
  },
  singleKeyIdConfig: {
    enableOverlay: true,
    cookieName: "skidCookieName",
  },
  token: {
    _csrf: "",
    _jwt: "",
  },
  translation: translation,
  deliveryDateFormat: "MM/dd/yyyy",
  consents: {
    countryBasedApi: "",
  },
};
